import React from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

/* ================= AUTH & PUBLIC ================= */
import Login from "./components/Login";
import Logout from "./components/Logout";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";

/* ================= COMMON ================= */
import Template from "./components/template";

/* ================= ADMIN ================= */
import AdminDashboard from "./components/admin/AdminDashboard";
import AdminAddZsm from "./components/admin/AddZsm";
import AdminAddAsm from "./components/admin/AddAsm";
import AdminAddSm from "./components/admin/AddSm";
import AdminAddDealer from "./components/admin/AddDealer";
import Zsm_management from "./components/admin/Zsm_management";
import Asm_management from "./components/admin/Asm_management";
import Sm_management from "./components/admin/Sm_management";

/* ================= ZSM ================= */
import ZsmDashboard from "./components/zsm/ZsmDashboard";

/* ================= ASM ================= */
import AsmDashboard from "./components/asm/AsmDashboard";

/* ================= SM ================= */
import SmDashboard from "./components/sm/SmDashboard";

import AsmTransfer from "./components/admin/AsmTransfer";

import SmTransfer from "./components/admin/Sm_tranfer";
import DealerTransfer from "./components/admin/DealerTransfer";

/* ================= CONFIG ================= */


const production = true;
export const withCredentials = true;
export const BASE_URL = production?"https://www.hfinpro.com/":"https://www.hfinprimum.com/"
export const APP_URL = BASE_URL+"backend/webpanel_api/"

export const api = APP_URL


/* ================= SESSION HELPER ================= */
const getSession = () => {
  try {
    const raw = localStorage.getItem("userSession");
    if (!raw) return null;

    const session = JSON.parse(raw);
    const user = session?.user;

    if (!user || (!user.role && !user.userlevel)) return null;
    return user;
  } catch {
    return null;
  }
};

/* ================= ROUTE GUARDS ================= */
const RequireAdmin = ({ children }) => {
  const user = getSession();
  const role = String(user?.role || user?.userlevel || "").toUpperCase();
  if (role !== "ADMIN") {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

const RequireZsm = ({ children }) => {
  const user = getSession();
  const role = String(user?.role || user?.userlevel || "").toUpperCase();
  if (role !== "ZSM") {
    return <Navigate to="/zsm/login" replace />;
  }
  return children;
};

const RequireAsm = ({ children }) => {
  const user = getSession();
  const role = String(user?.role || user?.userlevel || "").toUpperCase();
  if (role !== "ASM") {
    return <Navigate to="/asm/login" replace />;
  }
  return children;
};

const RequireSm = ({ children }) => {
  const user = getSession();
  const role = String(user?.role || user?.userlevel || "").toUpperCase();
  if (role !== "SM") {
    return <Navigate to="/sm/login" replace />;
  }
  return children;
};

/* ================= MAIN APP ================= */
function App() {
  return (
    <Router>
      <Routes>
        {/* ================= PUBLIC ROUTES ================= */}
        <Route path="/admin/login" element={<Login role="ADMIN" />} />
        <Route path="/zsm/login" element={<Login role="ZSM" />} />
        <Route path="/asm/login" element={<Login role="ASM" />} />
        <Route path="/sm/login" element={<Login role="SM" />} />
        <Route path="/dealer/login" element={<Login role="DEALER" />} />

        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* ================= ADMIN ================= */}
        <Route
          path="/admin/dashboard/*"
          element={
            <RequireAdmin>
              <Template />
            </RequireAdmin>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="add-zsm" element={<AdminAddZsm />} />
          <Route path="add-asm" element={<AdminAddAsm />} />
          <Route path="add-sm" element={<AdminAddSm />} />
          <Route path="add-dealer" element={<AdminAddDealer />} />
          <Route path="zsm-management" element={<Zsm_management />} />
          <Route path="asm-management" element={<Asm_management />} />
          <Route path="sm-management" element={<Sm_management />} />
          <Route path="sm-transfer" element={<SmTransfer />} />
          <Route path="asm-transfer" element={<AsmTransfer />} />
          <Route path="dealer-transfer" element={<DealerTransfer />} />
          <Route path="logout" element={<Logout role="ADMIN" />} />
        </Route>

        {/* ================= ZSM ================= */}
        <Route
          path="/zsm/dashboard/*"
          element={
            <RequireZsm>
              <Template />
            </RequireZsm>
          }
        >
          <Route index element={<ZsmDashboard />} />
          <Route path="logout" element={<Logout role="ZSM" />} />
        </Route>

        {/* ================= ASM ================= */}
        <Route
          path="/asm/dashboard/*"
          element={
            <RequireAsm>
              <Template />
            </RequireAsm>
          }
        >
          <Route index element={<AsmDashboard />} />
          <Route path="logout" element={<Logout role="ASM" />} />
        </Route>

        {/* ================= SM ================= */}
        <Route
          path="/sm/dashboard/*"
          element={
            <RequireSm>
              <Template />
            </RequireSm>
          }
        >
          <Route index element={<SmDashboard />} />
          <Route path="logout" element={<Logout role="SM" />} />
        </Route>

        {/* ================= DEFAULT / FALLBACK ================= */}
        <Route path="/" element={<Navigate to="/admin/login" replace />} />
        <Route path="*" element={<Navigate to="/admin/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;